// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper--B_lQi"};